<template>
  <div>

    <div class="banner withoutImg">
      <div class="container">
        <div class="caption">
          <h1>品鉴报告</h1>
          <div>
            <p>有关勃艮第产区的品鉴报告</p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <p>&nbsp;</p>
      <div class="breadcrumbWrap">
        <div class="breadcrumb">
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
          <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="品鉴报告"
                href="#/Appraisal"
                class="home"
              >
                <span property="name">品鉴报告</span>
              </a>
              <meta property="position" content="2">
            </span>/
          <span property="itemListElement" typeof="ListItem">
                <span property="name">{{detailContent.title}}</span>
                <img src="./../assets/bookmark_before.png" alt="" @click="shuqian(detailContent.id)">
              <meta property="position" content="3">
            </span>
        </div>
      </div>
    </div>
    <section class="innerPage">


      <div class="container">
        <rightMenu title="分类" :menudata='rightListdata' @OnClick='rightClick'/>


        <div style="margin-top:20px;max-width: 80%;margin-left: auto;margin-right: auto;" class="leftCol">
          <div>
            <h4 style="text-align: left;">{{detailContent.title}}</h4>
          </div>
          <div style="margin-top:25px;">
            <div style="float: left">
              <img :src="detailContent.avator" style="width: 50px;border-radius:25px;">
            </div>
            <div style="font-size: 14px;">
              <div>
                <span style="margin-left: 15px;">作&nbsp;&nbsp;者：{{detailContent.author}}</span>
              </div>
              <div>
                <span style="margin-left: 15px;">日&nbsp;&nbsp;期：{{detailContent.createTime}}</span>
              </div>
            </div>
          </div>
          <div v-if="detailContent.image" style="margin-top:25px;">
            <img :src="detailContent.image">
          </div>
          <section style="margin-top:20px;position:relative" v-if='detailContent.havePermission'
                   v-html="detailContent.contentHtml">
          </section>
          <template v-else>
            <section style="margin-top:20px;position:relative" v-if='!detailContent.havePermission'>
              <p>{{detailContent.introduction}}</p>
              <div class="contentmask"></div>
            </section>

          </template>
        </div>
      </div>
      <div class="container">
        <div class="whySubscribe " v-if='!detailContent.havePermission'>
          <div class="whySubscribeText animate fadeInUp triggeredCSS3">
            <a href="#/Subscribe" style="text-decoration:none;">
              <h1>为什么订阅Inside Burgundy</h1>
            </a>
            <ul>
              <li>通过订阅您将获得所有的品鉴报告及过往酒评</li>
              <li>您可通过网页、微信小程序、App（开发中）全平台查看酒评，方便快捷</li>
              <li>做为订阅用户，您将获赠Inside Burgundy的定制版Riedel勃艮第酒杯一支</li>
              <li>订阅费用为800元/年</li>
            </ul>
            <a href="#/Subscribe" target class="btn white">立即订阅</a>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
  import ajax from '../ajax'
  import searchBox from '../template/search'
  import rightMenu from '../template/rightMenu';

  export default {
    components: {
      searchBox,
      rightMenu
    },
    mounted() {

    },
    data() {
      return {
        detailContent: {},
        rightListdata: {},
        userId: "",
        relatedType: "",
        relatedId: "",
      }
    },
    created() {
      this.getdetail()
      this.getRightdata()

    },
    methods: {
      getRightdata() {
        ajax.getReportCategories().then(res => {
          this.rightListdata = res.data
        })
      },
      shuqian(id) {
        ajax.getVserInfe({
            userId: this.$store.state.userdata.userId,
            relatedType: 0,
            relatedId: id,
          }
          // this.$store.state.userdata.userId
        ).then(res => {
          console.log(res.data);
          alert("已添加到书签");
        });
        console.log(id)
      },
      rightClick(data) {
        if (!data.child && data.id)
          this.$router.push({path: '/Qualification', query: {id: data.id}})
      },
      getdetail() {
        ajax.getTastingDetail(this.$route.query.id).then(res => {
          this.detailContent = res.data
        })
      },
      changeActive($event) {
        $event.currentTarget.style = "border-bottom: 4px solid #990033;";
      },
      removeActive($event) {
        $event.currentTarget.style = "";
      },

    },
    watch: {
      $route(newValue) {
        console.log(newValue)
        this.getdetail()
      }
    },
  };
</script>





// WEBPACK FOOTER //
// src/components/Qualification.vue